module.exports = __webpack_public_path__ + "static/media/turnover-left.56518df4.png";